module.exports = __webpack_public_path__ + "static/media/faithful-gould.1b214fe4.JPG";